import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=5d0d096d&scoped=true"
import script from "./BarChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./BarChart.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=5d0d096d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0d096d",
  null
  
)

export default component.exports